import type { SiteConfig } from '../../@types/context/site-config.types';

export const organisationZmartaFiConfig: Pick<SiteConfig, 'organisation'> = {
  organisation: {
    name: 'Freedom Rahoitus Oy',
    number: '2207313-9',
  },
};
